module.exports = __webpack_public_path__ + "img/uploadimg@2x.7fe77304.png";